import React from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { Col, Row } from 'reactstrap';
import './index.css';
import Storage from '../../services/Storage';
import { Roles } from '../../constants/Roles';

const OwnerInformation = ({
  activeOwner,
  previewData,
  selectedOwnerCity,
  userId,
}) => {
  const navigate = useNavigate();
  const location = useLocation();

  let userInfo = Storage.getUserInfoDetail();
  let roleId = userInfo ? userInfo.id : null;
  let roleName = userInfo ? userInfo.role : '';

  const setBreadcrumbsRecord = () => {
    if (previewData.business_name) {
      Storage.setBreadcrumbsrRecord([
        {
          title: 'Preview App',
          url: location.pathname,
        },
        {
          title: previewData.business_name,
          url: `/pages/new-dealer/${previewData.id}`,
        },
      ]);
    }
  };
  return (
    <div>
      {activeOwner &&
        activeOwner.map((val, index) => {
          return (
            <div id='Ownerinformation' key={index}>
              <Row>
                <Col xs={12}>
                  <div className='main-title'>
                    {"Dealer's Information"}
                    {roleName &&
                      (roleName === Roles.TM_NAME ||
                        roleName === Roles.BH_NAME ||
                        (roleName === Roles.SH_NAME &&
                          previewData.created_by &&
                          previewData.created_by === roleId)) ? (
                      <i
                        onClick={() => {
                          setBreadcrumbsRecord();
                          navigate(
                            `/pages/add-owner/${Storage.getAddNewDealerId() ? Storage.getAddNewDealerId() : userId
                            }`
                          );
                        }}
                        className='fa fa-edit editButton noprint'
                      ></i>
                    ) : (
                      ''
                    )}
                  </div>
                </Col>
              </Row>
              <Row>
                <Col lg={12}>
                  {val.is_primary_contact && (
                    <div className='common-title'>Active Owner</div>
                  )}
                  <div className='ownerdatablock'>
                    <div className='info'>
                      <div className='common-heading'>Dealership Name</div>
                      <div className='subData'>{previewData.business_name}</div>
                    </div>
                    <div className='info'>
                      <div className='common-heading'>Owner's Name</div>
                      {/* <div className='subData'>{dealerTitle ? previewData.business_name : val.name}</div> */}
                      <div className='subData'>{val.name}</div>
                    </div>
                    <div className='info'>
                      <div className='common-heading'>Designation</div>
                      {/* <div className='subData'>{dealerTitle ? previewData.business_name : val.name}</div> */}
                      <div className='subData'>{val.designation}</div>
                    </div>
                    <div className='info'>
                      <div className='common-heading'>Mobile No</div>
                      <div className='subData'>{val.mobile_number}</div>
                    </div>
                    <div className='info'>
                      <div className='common-heading'>Whatsapp No</div>
                      <div className='subData'>
                        {val.whatsapp_mobile_number}
                      </div>
                    </div>
                    <div className='info'>
                      <div className='common-heading'>Email</div>
                      <div className='subData'>{val.email}</div>
                    </div>
                    {selectedOwnerCity.length > 0 &&
                      selectedOwnerCity.map((val, index) => {
                        return (
                          <div className='info' key={index}>
                            <div className='common-heading'>City/Town</div>
                            <div className='subData'>
                              {val.city_or_town_name}
                            </div>
                          </div>
                        );
                      })}
                    {previewData.territory_name && (
                      <div className='info'>
                        <div className='common-heading'>Territory</div>
                        <div className='subData'>
                          {previewData.territory_name}
                        </div>
                      </div>
                    )}
                  </div>
                </Col>
              </Row>
            </div>
          );
        })}
    </div>
  );
};

export default React.memo(OwnerInformation);
